export default __webpack_public_path__ + "static/media/deco-img(1).18fa0644.png";